import axios from 'axios';
import store from '../store';
import router from '../router';

const api = axios.create({
  baseURL: 'https://abc.atmcorr.com/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true
});

// 请求拦截器
api.interceptors.request.use(config => {
  // 从localStorage获取token
  const token = localStorage.getItem('token');
  
  // 如果token存在，注入Authorization头部
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 检查响应数据结构
    if (response.data && typeof response.data === 'object') {
      return response.data;
    }
    return response;
  },
  error => {
    console.error('API Error:', error);
    if (error.response && error.response.status === 401) {
      store.dispatch('user/logout');
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

export default api;
